import {
    createRegisterableComponentWithData,
    Election,
    ElectionDataLoader,
} from '@news-mono/web-common'
import React from 'react'
import HeadToHeadSeatCountWidget from './HeadToHeadSeatCountWidget'

export interface HeadToHeadSeatCountWidgetRouteProps {
    election: Election
}

export const HeadToHeadSeatCountWidgetRegistration =
    createRegisterableComponentWithData(
        'election-head-to-head-seat-count-widget',
        ElectionDataLoader,
        (props: HeadToHeadSeatCountWidgetRouteProps, data, services) => {
            return (
                <HeadToHeadSeatCountWidget
                    data={data}
                    onEvent={services.onEvent}
                    {...props}
                />
            )
        },
    )
